__turbopack_context__.v({
  "h4": "PlasmicCard-module__TWHy7q__h4",
  "p": "PlasmicCard-module__TWHy7q__p",
  "root": "PlasmicCard-module__TWHy7q__root",
});
